import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import style from "./Modal.module.css";
import moment from "moment";
import {
	Row,
	Col,
	Button,
	Card,
	Table,
	Form,
	Container,
	Modal,
	Tabs,
	Tab,
} from "react-bootstrap";
import { FaTachometerAlt, FaCalendarAlt, FaUsers, FaUser, FaArrowRight, FaSpinner, FaLifeRing, FaUndoAlt } from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan, FaS} from "react-icons/fa6";
import { apiCall } from "../api/apiUtil";
import { use } from "react";

function VendorDashboardPage() {
    const [globalCode, setGlobalCode] = useState(null);
    const [vendorCode, setVendorCode] = useState(null);
    const [isEmployee, setIsEmployee] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [finYear, setFinYear] = useState("");
    
    const [complianceCount, setComplianceCount] = useState(0);
    const [completedCount, setCompletedCount] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);

    const [selectedTab, setSelectedTab] = useState("");
    const [declarationFlag, setDeclarationFlag] = useState(false);
    
    const [categories, setCategories] = useState([]);
    const [filterCategories, setFilterCategories] = useState([]);
    const [filterCategory, setFilterCategory] = useState(null);
    const [filterIndex, setFilterIndex] = useState(null);
    const [fileUploadingFlag, setFileUploadingFlag] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState("");

    const getFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0 = Jan
        let fy = "";
        
        if (month >= 3) { // April or later
            fy = `${year}-${(year + 1).toString().slice(-2)}`;
        } else {
            fy = `${year - 1}-${year.toString().slice(-2)}`;
        }
        setFinYear(fy);        
        return fy;
    };

    const [selectedMonth, setSelectedMonth] = useState(() => {
        const today = moment();
        // // Get Current week's Monday
        // const currentMonday = moment().startOf('week').add(1, 'day');
        // // Get Current week's Sunday
        // const currentSunday = moment(currentMonday).add(6, 'days'); // this Monday + 6 = Current Sunday
        // // Build this month's 24th date
        // const thisMonth24th = moment().date(24);
        // const is24thInRange = thisMonth24th.isSameOrAfter(currentMonday, 'day') && thisMonth24th.isSameOrBefore(currentSunday, 'day');

        getFinancialYear(today.toDate());

        return today.toDate();
    });
    
    const [supportVendorCode, setSupportVendorCode] = useState("");
    const [supportModeActive, setSupportModeActive] = useState(null);

    const navigate = useNavigate();
    
    useEffect(() => {
        //console.log("Global Code", sessionStorage.getItem("globalCode"));
        let supportModeActive = localStorage.getItem("supportModeActiveVendor") === "true";
        let vendorCode = sessionStorage.getItem("vendorCode");
        let loginType = sessionStorage.getItem("loginType");
        let globalCode = sessionStorage.getItem("globalCode");
        setSupportModeActive(supportModeActive);

        if(vendorCode) {
            setVendorCode(vendorCode);
            getSelfConditions(vendorCode);
        } else if(globalCode) {
            setGlobalCode(globalCode);
            //getRoles(sessionStorage.getItem("globalCode"));
            if(supportModeActive) {
                setSupportVendorCode(localStorage.getItem("supportVendorCode"));
            }
        }
        else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        //console.log("Global Code", sessionStorage.getItem("globalCode"));
        //let globalCode = sessionStorage.getItem("globalCode");		
        setCategories([]);
        setFilterCategories([]);
        if(vendorCode || globalCode) {
            if(supportModeActive) {
                if(supportVendorCode) {
                    getSelfConditions(supportVendorCode);
                }
            } else {
                getSelfConditions(vendorCode);
            }
        }
    }, [vendorCode, supportVendorCode, finYear, supportModeActive]);

    useEffect(() => {
        //getSelfConditions(globalCode);
        if((categories ?? []).length > 0) {
            let filterCategories = categories?.filter((category) =>
                selectedTab === "Monthly" ? category.frequency === "Monthly"
                : selectedTab === "Yearly" ? category.frequency === "Yearly" : true
            );
            setFilterCategories(filterCategories);
        } else {
            setFilterCategories([]);
        }
    }, [vendorCode, supportVendorCode, selectedTab, categories]);

    const handleSupportMode = () => {
		localStorage.setItem("supportModeActiveVendor", !supportModeActive);
		localStorage.setItem("supportVendorCode", "");
		setSupportVendorCode("");
		setSupportModeActive(!supportModeActive);
	}

    const updateSupportVendorCode = (value) => {
		setSupportVendorCode(value);
		localStorage.setItem("supportVendorCode", value);
		if(value.trim() !== "") {
			//getSelfConditions(value);
		}
	}

    const getSelfConditions = (vendorCode) => {
        let vendorObj = {
            "vendorCode": vendorCode
        }
        apiCall(`/VendorCompliance/GetIndividualVendorCompliances/${finYear}` , {
            method: "POST",
            headers: { "Content-Type": "application/json" },
			body: JSON.stringify(vendorObj),
        })
        .then((response) => {
            let data = response?.data ?? [];
            //console.log("Backend Response:", data);
            setCategories(data ?? []);
            setFilterCategories([]);
            // setCounters(data);
            if(data?.filter((category) => category.frequency === "Monthly").length > 0)
                setSelectedTab("Monthly");
            else if(data?.filter((category) => category.frequency === "Yearly").length > 0)
                setSelectedTab("Yearly");
            else setSelectedTab("");
            // if (data.success) {
            // 	sessionStorage.setItem("userRoles", data?.user?.userRoles);
            // }
        })
        .catch((err) => {
            alert(err);
            console.error("Error:", err);
        });
    };

    useEffect(() => {
        getFinancialYear(selectedMonth);
    }, [selectedMonth]);

    const handleShowModal = (index, category) => {
        if(!supportModeActive) {
            setFilterIndex(index);
            setFilterCategory(category);

            if (category?.category?.toUpperCase() == "COC") {
                sessionStorage.setItem("VendorCoCComplianceId", category?.id);
                sessionStorage.setItem("startDate", category?.startDate);
                sessionStorage.setItem("endDate", category?.endDate);
                sessionStorage.setItem("year", category?.year);
                sessionStorage.setItem("month", category?.month);
                sessionStorage.setItem("period", category?.week);
                sessionStorage.setItem("place", category?.location);

                navigate("/VendorCOCForm");
            }
        }
    };
    const handleViewDetails = (category) => {
        setModalTitle(`${category?.category} - ${(category?.week ?? category?.month + " - " + category?.year)}`);
        setModalContent(
            <>
                {((category?.roExceptionalAck ?? false) || (category?.selfExceptionalAck ?? false)) && (
                    <>
                        <h5>Exception Condition</h5>
                        <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Exception Requested</th>
                                        <th>Self Exc. Evidence</th>
                                        <th>Exc. Requested On</th>
                                        <th>RO Exc. Review Status</th>
                                        <th>RO Exc. Evidence</th>
                                        <th>RO Exc. Reviewd On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td>{category?.selfExceptionalAck ? "Yes" : "-"}</td>
                                    <td>{(category?.selfExceptionalEvidence != null && category?.selfExceptionalEvidence?.trim() != "") ? (
                                        <a href={JSON.parse(category?.selfExceptionalEvidence ?? "{}")?.fileUrl ?? "javascript:void(0);"} target="_blank" rel="noopener noreferrer">{"View File"}</a>
                                    ) : (
                                        "-"
                                    )}
                                    </td>
                                    <td>{(category?.selfExceptionalAckOn != null) ? moment(category?.selfExceptionalAckOn).format("DD/MMM/YYYY HH:mm") : "-"}</td>
                                    <td>{category?.roExceptionalStatus ?? "Pending At RO"}</td>
                                    <td>{category?.roExceptionalEvidence != null ? (
                                        <a href={JSON.parse(category?.roExceptionalEvidence ?? "{}")?.fileUrl ?? "javascript:void(0);"} target="_blank" rel="noopener noreferrer">{"View File"}</a>
                                    ) : (
                                        "-"
                                    )}
                                    </td>
                                    <td>{(category?.roExceptionalAckOn != null) ? moment(category?.roExceptionalAckOn).format("DD/MMM/YYYY HH:mm") : "-"}</td>
                                </tbody>
                            </Table>
                        </div>
                        <h5>Normal Condition</h5>
                    </>
                )}
                <div className="table-responsive">
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Acknowledgement No</th>
                                <th>Self Declared</th>
                                <th>Evidence</th>
                                <th>Self Declared On</th>
                                <th>Self Status</th>
                                <th>Updated On</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{category?.acknowledgementNo ?? "-"}</td>
                                <td>{category?.selfAck ? "Yes" : "-"}</td>
                                <td>{category?.selfEvidence != null ? (
                                    <a href={JSON.parse(category?.selfEvidence ?? "{}")?.fileUrl ?? "javascript:void(0);"} target="_blank" rel="noopener noreferrer">{"View File"}</a>
                                ) : (
                                    "-"
                                )}
                                </td>
                                <td>{(category?.selfAckOn != null) ? moment(category?.selfAckOn).format("DD/MMM/YYYY HH:mm") : "-"}</td>
                                <td>{category?.selfStatus ?? "-"}</td>
                                <td>{(category?.updatedOn != null) ? moment(category?.updatedOn).format("DD/MMM/YYYY HH:mm") : "-"}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </>			
        );
        setShowModal(true);
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <Container className="flex-grow-1 mt-3 mb-3">
                <div className="row">
                    <div className="col bg-light mb-2 d-flex justify-content-between align-items-center">
                        <h5 className="mt-1">
                            <FaTachometerAlt className="me-2" /> Self Dashboard
                        </h5>
                        {(supportModeActive) && (
                        <div className="gap-2 ms-auto" style={{width: "250px"}}>
                            <div className="form-group text-white">
                                <label style={{color: "#000"}} htmlFor="email">View Dashboard Of</label>
                                <input type="text" id="UserGlobalCode" value={supportVendorCode}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            updateSupportVendorCode(e.target.value);
                                        }
                                    }} onChange={(e) => setSupportVendorCode(e.target.value)} onBlur={(e) => updateSupportVendorCode(e.target.value)} placeholder="Enter Employee Code" required autoComplete="off" />
                            </div>
                        </div>
                        )}
                        <div className="gap-2 ms-auto" style={{width: "250px"}}>
                            <label className="align-items-center">Financial Year: {finYear}</label>
                            {/* Month Picker with Calendar Icon inside Input */}
                            <div className="position-relative">
                                <DatePicker selected={selectedMonth} onChange={(date) => setSelectedMonth(date)} dateFormat="MMMM yyyy" showMonthYearPicker className="form-control pe-5" />
                                {/* Calendar Icon Inside Input */}
                                <FaCalendarAlt className="position-absolute text-muted"
                                    style={{
                                        top: 20,
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        fontSize: "1.2rem",
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        document
                                            .querySelector(".react-datepicker__input-container input")
                                            .focus()
                                    } // Trigger DatePicker on click
                                />
                                {/* <span style={{fontSize: "13px", color: "red"}}>24th of {moment(selectedMonth).subtract(1, "M").format("MMMM YYYY")} to 23rd of {moment(selectedMonth).format("MMMM YYYY")}</span> */}
                            </div>
                            {/* <Button variant="success" size="sm">
                                Completed
                            </Button> */}
                        </div>
                    </div>
                </div>
                <Row className="mb-2">
                    <Col md={12} className="d-flex justify-content-end">
                        <Button variant="primary" size="sm" className="me-2">
                            Total Compliance{" "}
                            <span className="badge bg-light text-dark ms-2">
                                {complianceCount}
                            </span>
                        </Button>
                        <Button variant="success" size="sm" className="me-2">
                            Completed{" "}
                            <span className="badge bg-light text-dark ms-2">
                                {completedCount}
                            </span>
                        </Button>
                        <Button variant="warning" size="sm" className="me-2">
                            Pending For Declare{" "}
                            <span className="badge bg-light text-dark ms-2">
                                {pendingCount}
                            </span>
                        </Button>
                        {/* {(Array.isArray(userRoles) && userRoles.some(role => role.role === "RO") || supportModeActive) && (
                        <a href="/ro-dashboard" className="me-3">
                            <Button variant="success" size="sm">
                                <FaUsers className="me-2" /> Team Review
                            </Button>
                        </a>
                        )}
                        {Array.isArray(userRoles) && userRoles.some(role => role.role == "Support") && (
                            <Button variant={supportModeActive ? "success" : "secondary"} onClick={()=>handleSupportMode()} size="sm">
                                <FaLifeRing className="me-2" /> {supportModeActive ? "Deactivate Support Mode" : "Activate Support Mode"}
                            </Button>
                        )}

                        {Array.isArray(userRoles) && userRoles.some(role => role.role === "HR Head") && (
                            <a href="/hr-dashboard" className="me-3">
                                <Button variant="info" size="sm">
                                    <FaUser className="me-2" /> Location HR View
                                </Button>
                            </a>
                        )}

                        {Array.isArray(userRoles) && userRoles.some(role => role.role === "Payroll") && (
                            <a href="/payroll-dashboard" className="me-3">
                                <Button variant="info" size="sm">
                                    <FaUser className="me-2" /> Payroll View
                                </Button>
                            </a>
                        )}

                        {userRoles.some(role => role.role === "Admin") && (
                            <a href="/admin-dashboard">
                                <Button variant="info" size="sm">
                                    <FaUser className="me-2" /> Admin
                                </Button>
                            </a>
                        )} */}
                    </Col>
                </Row>
                <Tabs activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="mb-3">
                    {(categories ?? []).length == 0 ? (<Tab eventKey="" title="No Content" />) : (<></>)}
                    {(categories?.filter((category) => category.frequency === "Monthly").length > 0) ? (<Tab eventKey="Monthly" title="Monthly" />) : (<></>)}
                    {(categories?.filter((category) => category.frequency === "Yearly").length > 0) ? (<Tab eventKey="Yearly" title="Yearly" />) : (<></>)}
                </Tabs>
                <div className="d-flex justify-content-end">
                    <a href="/business-interest-vendorview" className="me-3">
                        <Button variant="warning" size="sm">
                            <FaUsers className="me-2" /> Business Interest Status
                        </Button>
                    </a>
                </div>
                <Card>
                    <Card.Body>
                        <div className="table-responsive">
                            <Table striped bordered hover className="mt-3">
                                <thead>
                                    <tr>
                                        <th>Conditions</th>
                                        <th>Compliance Freqency</th>
                                        <th className="text-center">Self Acknowledgement</th>
                                        <th className="text-center">Final Status</th>
                                        <th className="text-center">View Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filterCategories) && filterCategories.map((category, index) => (
                                        <tr key={index}>
                                            <td>
                                                {category?.category}
                                                {category?.category?.toUpperCase() === "CoC" && (
                                                    <><br />(Vendor Code of Conduct)</>
                                                )}
                                            </td>
                                            <td>
                                                {category?.frequency} <br />
                                                {moment(category?.startDate).format("DD-MMM-yyyy") + " To " + moment(category?.endDate).format("DD-MMM-yyyy")}
                                            </td>
                                            <td className="text-center">
                                                {(category?.selfAck ?? false) && 
                                                    <Button variant="success" size="sm" style={{width: 150}}>{"Declared"}</Button>
                                                }
                                                {!(category?.selfAck ?? false) &&
                                                    <Button variant="warning" size="sm" style={{width: 150}} onClick={() => handleShowModal(index, category)}>
                                                        Pending to Declare
                                                    </Button>
                                                }
                                            </td>
                                            <td className="text-center">
                                                {((category?.selfStatus ?? "") == "Auto OCR Verification Completed") && 
                                                    <Button variant="success" size="sm" style={{width: 250}}>{category?.selfStatus}</Button>
                                                }
                                                {((category?.selfStatus ?? "") == "Auto OCR Verification Failed") && 
                                                    <Button variant="danger" size="sm" style={{width: 250}}>{category?.selfStatus}</Button>
                                                }                                                
                                                {((category?.selfStatus ?? "") == "") && 
                                                    <Button variant="warning" size="sm" style={{width: 250}}>
                                                        Auto OCR Verification Pending
                                                    </Button>
                                                }
                                            </td>
                                            <td className="text-center">
                                                <Button size="sm" onClick={() => handleViewDetails(category)} style={{width: 80}}>View</Button>&nbsp;
                                            </td>
                                        </tr>
                                    ))}
                                    {(Array.isArray(filterCategories) && filterCategories.length === 0) && 
                                        (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">
                                                No records found
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
                <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalContent}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </div>
    );
}

export default VendorDashboardPage;